import React from 'react';

export default function NSFWBadge() {
  return (
    <span className="absolute right-2 top-2 z-20 rounded-md bg-zinc-950/80 px-2 py-0.5 text-[11px] font-semibold tracking-wide text-white ring-1 ring-white/20 backdrop-blur-sm">
      18+
    </span>
  );
}
